
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { ValidationProvider } from 'vee-validate';
import { Provider } from '@/types';
import TextButton from '@/components/shared/suites/TextButton.vue';
import TextField from '@/components/shared/TextField.vue';
import InfoBanner from '@/components/shared/suites/InfoBanner.vue';
import Toast from '@/utils/toast';

const namespace: string = 'orders';

@Component<ManualDiscount>({
	components: {
		TextField,
		TextButton,
		ValidationProvider,
		InfoBanner
	}
})
export default class ManualDiscount extends Vue {
	@Action('validateDiscount', { namespace }) private validateDiscount!: (payload: { percentage?: number }) => Promise<void>;
	@Action('clearDiscount', { namespace }) private clearDiscount!: () => Promise<void>;
	@Getter('getDiscountInfo', { namespace }) private discountInfo!: CostsDiscount | null;
	@Prop({ type: Boolean, default: false }) private isManualDiscountApplied!: boolean;

	$refs!: { discountPercentageInput: Provider; };

	private discountPercentage: number | null = null;
	private isApplyingDiscount: boolean = false;
	private isRemovingDiscount: boolean = false;

	private created(): void {
		if (this.isManualDiscountApplied && this.discountInfo?.percentageValue) {
			this.discountPercentage = this.discountInfo.percentageValue;
		}
	}

	/**
	 * Remove the applied discount
	 *
	 * @return {Promise<void>}
	 */
	private async removeDiscount(): Promise<void> {
		this.isRemovingDiscount = true;

		try {
			await this.clearDiscount();
			this.discountPercentage = null;
			this.isRemovingDiscount = false;
		}
		catch (errorMessage) {
			Toast.error(this.$t('orders.guest_details.discount.error_removing', { errorMessage }));
			this.isRemovingDiscount = false;
		}
	}

	/**
	 * Apply the discount percentage
	 *
	 * @return {Promise<void>}
	 */
	private async applyDiscount(): Promise<void> {
		const isValid = await this.$refs.discountPercentageInput?.validate();
		if (!isValid) {
			return;
		}

		this.isApplyingDiscount = true;
		try {
			await this.validateDiscount({ percentage: this.discountPercentage! });
			this.isApplyingDiscount = false;
		}
		catch (errorMessage) {
			Toast.error(this.$t('orders.guest_details.discount.error_applying', { errorMessage }));
			this.isApplyingDiscount = false;
		}
	}
}
